import { LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { SELECTORS } from '../../constants/selectors';
import type { PointStatusResponse } from '../../types/account.types';

/**
 * ポイント表示コンポーネント
 *
 * @element kd-point-status
 * @description ポイントAPIを呼び出し、ポイント数と今月失効ポイントを表示更新する。
 *
 * @attr {string} api-url - ポイントAPI URL（デフォルト: /apps/kuradashi_point/point/）
 */
@customElement('kd-point-status')
export class KdPointStatus extends LitElement {
  createRenderRoot() {
    return this;
  }

  @property({ type: String, attribute: 'api-url' })
  apiUrl = '/apps/kuradashi_point/point/';

  connectedCallback(): void {
    super.connectedCallback();
    this.fetchPointStatus();
  }

  async fetchPointStatus(): Promise<void> {
    try {
      const response = await fetch(this.apiUrl, {
        method: 'POST',
        headers: { accept: 'application/json, text/plain, */*' },
        credentials: 'include',
      });

      const data: PointStatusResponse = await response.json();
      const formatter = new Intl.NumberFormat();

      const amountEl = this.querySelector(SELECTORS.ACCOUNT.POINT_AMOUNT);
      const expireEl = this.querySelector(SELECTORS.ACCOUNT.POINT_EXPIRE);

      if (amountEl) {
        amountEl.textContent = formatter.format(data.point);
      }
      if (expireEl) {
        expireEl.textContent = formatter.format(data.expiration_point);
      }
    } catch {
      // ポイント取得失敗時はサイレント（既存動作と同じ）
    }
  }

  render() {
    return nothing;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'kd-point-status': KdPointStatus;
  }
}
